import { ca } from '@cian/analytics';

import { EChatbotPayload } from '../../services/fetchChatbotActionButtons';

export const trackUnarchivedButtonClick = (opponentId?: number) => {
  ca('eventSite', {
    action: 'restore_message_from_archive',
    category: 'Chat',
    label: '',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
};

export const trackSendChatbotMessage = (text: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: EChatbotPayload.SendMessage,
    page: {
      extra: {
        chat_id: 'chatbot',
        text,
      },
    },
  });
};
